import { EuIcon, GbIcon, GlobeIcon, UsIcon } from '@joinrepublic/dls-ui-kit';

export const getRegionFlag = (variantId: string): JSX.Element => {
  const flags: Record<string, JSX.Element> = {
    global: <GlobeIcon boxSize="5" />,
    uk: <GbIcon boxSize="5" />,
    us: <UsIcon boxSize="5" />,
    europe: <EuIcon boxSize="5" />,
  };

  return flags[variantId] ?? '';
};
